/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestReset } from './QuestReset';
import {
    QuestResetFromJSON,
    QuestResetFromJSONTyped,
    QuestResetToJSON,
    QuestResetToJSONTyped,
} from './QuestReset';
import type { RewardConfigResponse } from './RewardConfigResponse';
import {
    RewardConfigResponseFromJSON,
    RewardConfigResponseFromJSONTyped,
    RewardConfigResponseToJSON,
    RewardConfigResponseToJSONTyped,
} from './RewardConfigResponse';
import type { QuestDisplay } from './QuestDisplay';
import {
    QuestDisplayFromJSON,
    QuestDisplayFromJSONTyped,
    QuestDisplayToJSON,
    QuestDisplayToJSONTyped,
} from './QuestDisplay';
import type { RewardGrant } from './RewardGrant';
import {
    RewardGrantFromJSON,
    RewardGrantFromJSONTyped,
    RewardGrantToJSON,
    RewardGrantToJSONTyped,
} from './RewardGrant';
import type { MilestoneWithGameMetadata } from './MilestoneWithGameMetadata';
import {
    MilestoneWithGameMetadataFromJSON,
    MilestoneWithGameMetadataFromJSONTyped,
    MilestoneWithGameMetadataToJSON,
    MilestoneWithGameMetadataToJSONTyped,
} from './MilestoneWithGameMetadata';
import type { QuestConfigMilestoneResponse } from './QuestConfigMilestoneResponse';
import {
    QuestConfigMilestoneResponseFromJSON,
    QuestConfigMilestoneResponseFromJSONTyped,
    QuestConfigMilestoneResponseToJSON,
    QuestConfigMilestoneResponseToJSONTyped,
} from './QuestConfigMilestoneResponse';
import type { PrerequisiteResponse } from './PrerequisiteResponse';
import {
    PrerequisiteResponseFromJSON,
    PrerequisiteResponseFromJSONTyped,
    PrerequisiteResponseToJSON,
    PrerequisiteResponseToJSONTyped,
} from './PrerequisiteResponse';

/**
 * 
 * @export
 * @interface QuestConfigWithGameMetadata
 */
export interface QuestConfigWithGameMetadata {
    /**
     * 
     * @type {Array<MilestoneWithGameMetadata>}
     * @memberof QuestConfigWithGameMetadata
     */
    milestones: Array<MilestoneWithGameMetadata>;
    /**
     * 
     * @type {number}
     * @memberof QuestConfigWithGameMetadata
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof QuestConfigWithGameMetadata
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigWithGameMetadata
     */
    id: string;
    /**
     * 
     * @type {Array<QuestDisplay>}
     * @memberof QuestConfigWithGameMetadata
     */
    displayedOn?: Array<QuestDisplay>;
    /**
     * 
     * @type {boolean}
     * @memberof QuestConfigWithGameMetadata
     */
    shouldDisplayUnqualified?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QuestConfigWithGameMetadata
     */
    requireProgressionOrder?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigWithGameMetadata
     */
    name: string;
    /**
     * Kicker rendered above the segment name on the journey map masthead (e.g. "Get in the Game" over Boot Camp).
     * @type {string}
     * @memberof QuestConfigWithGameMetadata
     */
    groupLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigWithGameMetadata
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QuestConfigWithGameMetadata
     */
    isActive: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QuestConfigWithGameMetadata
     */
    showQuestCompleteNotification?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigWithGameMetadata
     */
    questCompleteNotificationMessage?: string;
    /**
     * 
     * @type {QuestReset}
     * @memberof QuestConfigWithGameMetadata
     */
    questReset: QuestReset;
    /**
     * 
     * @type {Array<PrerequisiteResponse>}
     * @memberof QuestConfigWithGameMetadata
     */
    prerequisites: Array<PrerequisiteResponse>;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestConfigWithGameMetadata
     */
    rewardConfigIds?: Array<string>;
    /**
     * 
     * @type {Array<RewardConfigResponse>}
     * @memberof QuestConfigWithGameMetadata
     */
    rewardConfigs?: Array<RewardConfigResponse>;
    /**
     * Quest-level catalog-item grants (reward-catalog Option B) — additive alongside rewardConfigIds during the migration.
     * @type {Array<RewardGrant>}
     * @memberof QuestConfigWithGameMetadata
     */
    rewardGrants?: Array<RewardGrant>;
    /**
     * Per-reward auto-claim settings for quest-level rewards. Key is rewardConfigId, value is true for auto-reward, false for manual claim.
     * @type {{ [key: string]: boolean; }}
     * @memberof QuestConfigWithGameMetadata
     */
    rewardAutoSettings?: { [key: string]: boolean; };
    /**
     * 
     * @type {boolean}
     * @memberof QuestConfigWithGameMetadata
     */
    isSponsored?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigWithGameMetadata
     */
    sponsorName?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigWithGameMetadata
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigWithGameMetadata
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigWithGameMetadata
     */
    externalUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigWithGameMetadata
     */
    rewardImage?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigWithGameMetadata
     */
    backgroundImage?: string;
    /**
     * 
     * @type {number}
     * @memberof QuestConfigWithGameMetadata
     */
    startAt?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestConfigWithGameMetadata
     */
    endAt?: number;
    /**
     * Per-user relative completion window in days (unset = open-ended).
     * @type {number}
     * @memberof QuestConfigWithGameMetadata
     */
    completionWindowDays?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestConfigWithGameMetadata
     */
    maxUserCompletions?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestConfigWithGameMetadata
     */
    currentUserCompletions?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestConfigWithGameMetadata
     */
    linkedQuestConfigIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestConfigWithGameMetadata
     */
    partnerServiceIds?: Array<string>;
    /**
     * Cheat-filtering match-bracketing gate — when true, this quest only progresses while the user has an active Match Start or Round Start in Redis
     * @type {boolean}
     * @memberof QuestConfigWithGameMetadata
     */
    requireActiveMatch?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigWithGameMetadata
     */
    revealText?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigWithGameMetadata
     */
    ctaButtonText?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigWithGameMetadata
     */
    brandLinkText?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigWithGameMetadata
     */
    questHeader?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigWithGameMetadata
     */
    ctaStripColor?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigWithGameMetadata
     */
    playableAdLayout?: QuestConfigWithGameMetadataPlayableAdLayoutEnum;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigWithGameMetadata
     */
    headlineFont?: QuestConfigWithGameMetadataHeadlineFontEnum;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigWithGameMetadata
     */
    completeHeadline?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigWithGameMetadata
     */
    completeSubtext?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigWithGameMetadata
     */
    completeButtonText?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigWithGameMetadata
     */
    claimedHeadline?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigWithGameMetadata
     */
    claimedSubtext?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigWithGameMetadata
     */
    claimedSponsorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigWithGameMetadata
     */
    claimedCtaText?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigWithGameMetadata
     */
    claimedCtaUrl?: string;
}


/**
 * @export
 */
export const QuestConfigWithGameMetadataPlayableAdLayoutEnum = {
    STACKED: 'STACKED',
    SPLIT: 'SPLIT'
} as const;
export type QuestConfigWithGameMetadataPlayableAdLayoutEnum = typeof QuestConfigWithGameMetadataPlayableAdLayoutEnum[keyof typeof QuestConfigWithGameMetadataPlayableAdLayoutEnum];

/**
 * @export
 */
export const QuestConfigWithGameMetadataHeadlineFontEnum = {
    ARCHIVO_BLACK: 'ARCHIVO_BLACK',
    MONTSERRAT: 'MONTSERRAT',
    NUNITO_SANS: 'NUNITO_SANS',
    TEKO: 'TEKO'
} as const;
export type QuestConfigWithGameMetadataHeadlineFontEnum = typeof QuestConfigWithGameMetadataHeadlineFontEnum[keyof typeof QuestConfigWithGameMetadataHeadlineFontEnum];


/**
 * Check if a given object implements the QuestConfigWithGameMetadata interface.
 */
export function instanceOfQuestConfigWithGameMetadata(value: object): value is QuestConfigWithGameMetadata {
    if (!('milestones' in value) || value['milestones'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('questReset' in value) || value['questReset'] === undefined) return false;
    if (!('prerequisites' in value) || value['prerequisites'] === undefined) return false;
    return true;
}

export function QuestConfigWithGameMetadataFromJSON(json: any): QuestConfigWithGameMetadata {
    return QuestConfigWithGameMetadataFromJSONTyped(json, false);
}

export function QuestConfigWithGameMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestConfigWithGameMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'milestones': ((json['milestones'] as Array<any>).map(MilestoneWithGameMetadataFromJSON)),
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'id': json['id'],
        'displayedOn': json['displayedOn'] == null ? undefined : ((json['displayedOn'] as Array<any>).map(QuestDisplayFromJSON)),
        'shouldDisplayUnqualified': json['shouldDisplayUnqualified'] == null ? undefined : json['shouldDisplayUnqualified'],
        'requireProgressionOrder': json['requireProgressionOrder'] == null ? undefined : json['requireProgressionOrder'],
        'name': json['name'],
        'groupLabel': json['groupLabel'] == null ? undefined : json['groupLabel'],
        'description': json['description'] == null ? undefined : json['description'],
        'isActive': json['isActive'],
        'showQuestCompleteNotification': json['showQuestCompleteNotification'] == null ? undefined : json['showQuestCompleteNotification'],
        'questCompleteNotificationMessage': json['questCompleteNotificationMessage'] == null ? undefined : json['questCompleteNotificationMessage'],
        'questReset': QuestResetFromJSON(json['questReset']),
        'prerequisites': ((json['prerequisites'] as Array<any>).map(PrerequisiteResponseFromJSON)),
        'rewardConfigIds': json['rewardConfigIds'] == null ? undefined : json['rewardConfigIds'],
        'rewardConfigs': json['rewardConfigs'] == null ? undefined : ((json['rewardConfigs'] as Array<any>).map(RewardConfigResponseFromJSON)),
        'rewardGrants': json['rewardGrants'] == null ? undefined : ((json['rewardGrants'] as Array<any>).map(RewardGrantFromJSON)),
        'rewardAutoSettings': json['rewardAutoSettings'] == null ? undefined : json['rewardAutoSettings'],
        'isSponsored': json['isSponsored'] == null ? undefined : json['isSponsored'],
        'sponsorName': json['sponsorName'] == null ? undefined : json['sponsorName'],
        'logo': json['logo'] == null ? undefined : json['logo'],
        'color': json['color'] == null ? undefined : json['color'],
        'externalUrl': json['externalUrl'] == null ? undefined : json['externalUrl'],
        'rewardImage': json['rewardImage'] == null ? undefined : json['rewardImage'],
        'backgroundImage': json['backgroundImage'] == null ? undefined : json['backgroundImage'],
        'startAt': json['startAt'] == null ? undefined : json['startAt'],
        'endAt': json['endAt'] == null ? undefined : json['endAt'],
        'completionWindowDays': json['completionWindowDays'] == null ? undefined : json['completionWindowDays'],
        'maxUserCompletions': json['maxUserCompletions'] == null ? undefined : json['maxUserCompletions'],
        'currentUserCompletions': json['currentUserCompletions'] == null ? undefined : json['currentUserCompletions'],
        'linkedQuestConfigIds': json['linkedQuestConfigIds'] == null ? undefined : json['linkedQuestConfigIds'],
        'partnerServiceIds': json['partnerServiceIds'] == null ? undefined : json['partnerServiceIds'],
        'requireActiveMatch': json['requireActiveMatch'] == null ? undefined : json['requireActiveMatch'],
        'revealText': json['revealText'] == null ? undefined : json['revealText'],
        'ctaButtonText': json['ctaButtonText'] == null ? undefined : json['ctaButtonText'],
        'brandLinkText': json['brandLinkText'] == null ? undefined : json['brandLinkText'],
        'questHeader': json['questHeader'] == null ? undefined : json['questHeader'],
        'ctaStripColor': json['ctaStripColor'] == null ? undefined : json['ctaStripColor'],
        'playableAdLayout': json['playableAdLayout'] == null ? undefined : json['playableAdLayout'],
        'headlineFont': json['headlineFont'] == null ? undefined : json['headlineFont'],
        'completeHeadline': json['completeHeadline'] == null ? undefined : json['completeHeadline'],
        'completeSubtext': json['completeSubtext'] == null ? undefined : json['completeSubtext'],
        'completeButtonText': json['completeButtonText'] == null ? undefined : json['completeButtonText'],
        'claimedHeadline': json['claimedHeadline'] == null ? undefined : json['claimedHeadline'],
        'claimedSubtext': json['claimedSubtext'] == null ? undefined : json['claimedSubtext'],
        'claimedSponsorMessage': json['claimedSponsorMessage'] == null ? undefined : json['claimedSponsorMessage'],
        'claimedCtaText': json['claimedCtaText'] == null ? undefined : json['claimedCtaText'],
        'claimedCtaUrl': json['claimedCtaUrl'] == null ? undefined : json['claimedCtaUrl'],
    };
}

export function QuestConfigWithGameMetadataToJSON(json: any): QuestConfigWithGameMetadata {
    return QuestConfigWithGameMetadataToJSONTyped(json, false);
}

export function QuestConfigWithGameMetadataToJSONTyped(value?: QuestConfigWithGameMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'milestones': ((value['milestones'] as Array<any>).map(MilestoneWithGameMetadataToJSON)),
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'id': value['id'],
        'displayedOn': value['displayedOn'] == null ? undefined : ((value['displayedOn'] as Array<any>).map(QuestDisplayToJSON)),
        'shouldDisplayUnqualified': value['shouldDisplayUnqualified'],
        'requireProgressionOrder': value['requireProgressionOrder'],
        'name': value['name'],
        'groupLabel': value['groupLabel'],
        'description': value['description'],
        'isActive': value['isActive'],
        'showQuestCompleteNotification': value['showQuestCompleteNotification'],
        'questCompleteNotificationMessage': value['questCompleteNotificationMessage'],
        'questReset': QuestResetToJSON(value['questReset']),
        'prerequisites': ((value['prerequisites'] as Array<any>).map(PrerequisiteResponseToJSON)),
        'rewardConfigIds': value['rewardConfigIds'],
        'rewardConfigs': value['rewardConfigs'] == null ? undefined : ((value['rewardConfigs'] as Array<any>).map(RewardConfigResponseToJSON)),
        'rewardGrants': value['rewardGrants'] == null ? undefined : ((value['rewardGrants'] as Array<any>).map(RewardGrantToJSON)),
        'rewardAutoSettings': value['rewardAutoSettings'],
        'isSponsored': value['isSponsored'],
        'sponsorName': value['sponsorName'],
        'logo': value['logo'],
        'color': value['color'],
        'externalUrl': value['externalUrl'],
        'rewardImage': value['rewardImage'],
        'backgroundImage': value['backgroundImage'],
        'startAt': value['startAt'],
        'endAt': value['endAt'],
        'completionWindowDays': value['completionWindowDays'],
        'maxUserCompletions': value['maxUserCompletions'],
        'currentUserCompletions': value['currentUserCompletions'],
        'linkedQuestConfigIds': value['linkedQuestConfigIds'],
        'partnerServiceIds': value['partnerServiceIds'],
        'requireActiveMatch': value['requireActiveMatch'],
        'revealText': value['revealText'],
        'ctaButtonText': value['ctaButtonText'],
        'brandLinkText': value['brandLinkText'],
        'questHeader': value['questHeader'],
        'ctaStripColor': value['ctaStripColor'],
        'playableAdLayout': value['playableAdLayout'],
        'headlineFont': value['headlineFont'],
        'completeHeadline': value['completeHeadline'],
        'completeSubtext': value['completeSubtext'],
        'completeButtonText': value['completeButtonText'],
        'claimedHeadline': value['claimedHeadline'],
        'claimedSubtext': value['claimedSubtext'],
        'claimedSponsorMessage': value['claimedSponsorMessage'],
        'claimedCtaText': value['claimedCtaText'],
        'claimedCtaUrl': value['claimedCtaUrl'],
    };
}

